import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '@ts/shared/authentication/data-access-authenticated-guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'shop',
    pathMatch: 'full',
  },
  {
    path: 'checkout',
    canActivate: [AuthenticatedGuard],
    loadChildren: () =>
      import('@ts/checkout/feature-shell').then((module) => {
        return module.CheckoutFeatureShellModule;
      }),
  },
  {
    path: 'shop',
    loadChildren: () =>
      import('@ts/shop/feature-shell').then(
        (module) => module.ShopFeatureShellModule,
      ),
  },
  {
    path: '**',
    redirectTo: 'shop/not-found',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
